<template>
  <Popper
    v-model:open="menuOpen"
    placement="bottom-start"
  >
    <div class="type-select">
      <div
        v-for="item in navItems"
        :key="item.name"
      >
        <div class="type-select__group-name">
          {{ item.name }}
        </div>
        <ul class="type-select__items">
          <li
            v-for="link in item.links"
            :key="link.name"
            class="type-select__item"
          >
            <router-link
              activeClass="type-select__link--active"
              class="type-select__link"
              :to="{
                name: link.name,
                params: { issueType: link.type }
              }"
            >
              {{ link.label }}
              <CheckMarkIcon />
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <template #trigger>
      <div class="type-select__trigger">
        {{ currentPageTitle }}
        <ArrowDown />
      </div>
    </template>
  </Popper>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

// Components
import Popper from '@/components/generic/popper.vue';

// Icons
import ArrowDown from '@/images/arrow-down-16.svg';
import CheckMarkIcon from '@/images/checkmark.svg';

const props = defineProps({
  /** Navigation list */
  navItems: { type: Array, required: true, default: () => [] },
});

const route = useRoute();
const menuOpen = ref(false);

const currentPageTitle = computed(() => {
  let title;

  props.navItems.forEach((item) => {
    item.links.forEach((link) => {
      if (link.type === route.params.issueType) {
        title = link.label;
      }
    });
  });

  return title;
});
</script>

<style scoped lang="scss">
@import '@/stylesheets/global';

.type-select {
  background-color: map-get($background-color, light);
  display: flex;
  flex-direction: column;
  min-height: 45vh;

  &__group-name {
    background-color: map-get($background-color, dark);
    color: map-get($foreground-color, light);
    font-weight: 500;
    padding: bu(1.5);
  }

  &__link {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: bu(2) bu(2.25);

    svg {
      display: none;
    }

    &--active {
      svg {
        display: block;
        fill: $white;
      }
    }
  }

  &__trigger {
    align-items: center;
    cursor: pointer;
    display: flex;
    font-weight: 500;

    svg {
      margin-left: bu(0.5);
    }
  }
}
</style>
